import React from 'react';

import {observer} from 'mobx-react';
import {PredictionVoting} from "./voting/prediction.voting";
import {PredictionsOddsRow} from "./odds/predictions.odds-row";
import {PredictionResults} from "./results/prediction.results";
import classNames from "classnames";
import styles from "../style/prediction.module.scss";

export const PredictionVote = observer(({
                                          prediction,
                                          controller,
                                          showOdds,
                                          onVoteClick,
                                          betsImpressionParams
                                        }) => {
  const shouldRenderOdds: Boolean = prediction.hasOdds && showOdds && controller.state.appState.showOdds;
  const classNameContainer: String = prediction.enableVoting ? styles.votes_container : styles.results_container;

  const votingProps = {
    prediction,
    onVoteClick
  }

  const resultsProps = {
    prediction,
    controller
  }

  const oddsRowProps = {
    controller,
    prediction,
    betsImpressionParams,
    showOdds
  }

  return (
    <div className={classNames(classNameContainer, {[styles.no_odds_votes]: !shouldRenderOdds})}>
      <PredictionVoting {...votingProps}/>
      <PredictionResults {...resultsProps}/>
      <PredictionsOddsRow {...oddsRowProps}/>
    </div>
  )
});
